import { Translator } from '@miq/utils';
import { EDPSpaceInfo, SuiteType } from '../../stacking-plan-container/floor-container/floor/item/item.model';
import { AbstractSpaceClass } from './abstract-space.class';

export class UnaccountedSpaceClass extends AbstractSpaceClass {
  private unaccountedSpace: number;
  private unaccountedSpaceUOM: string;
  public notes = '-';

  constructor(
    unaccountedSpace: number,
    unaccountedSpaceUOM: string,
    private translationService: Translator,
    isHighlighted?: boolean
  ) {
    super(
      {
        suite_id: null,
        suite_number: null,
        suite_desc: null,
        occupancy_status: true,
        availability_status: true,
      },
      SuiteType.Unaccounted
    );
    this.unaccountedSpace = unaccountedSpace;
    this.unaccountedSpaceUOM = unaccountedSpaceUOM;
    this.isHighlighted = isHighlighted;
  }

  getAreaSpace(): number {
    return this.unaccountedSpace;
  }
  getAreaSpaceUOM(): string {
    return this.unaccountedSpaceUOM;
  }
  internalSpaceInfoClone(): Pick<EDPSpaceInfo, 'tenant' | 'lease' | 'availability' | 'non_rentable_space'> {
    return {
      availability: null,
      lease: null,
      non_rentable_space: null,
      tenant: null,
    };
  }

  toString(_?: { [key: string]: any }): string {
    return `${this.unaccountedSpace} ${this.unaccountedSpaceUOM}`;
  }

  enableEditEvent(): boolean {
    return true;
  }

  public getTitle() {
    return this.translationService.translate('filters.unaccounted');
  }
}
